import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Disable webpack dev server error overlay for cross-origin errors
if (typeof window !== 'undefined') {
  const origError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (message === 'Script error.' || (source && source === '')) return true;
    if (origError) return origError(message, source, lineno, colno, error);
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
